const apresentationcontententEN = [
    {id:1,
    title:"Keeper App",
    img:"https://github.com/RamonFavero/ramonportfolio/blob/main/src/img/keeperapp.png?raw=true",
    corpo:"This is a project simulating Google Keep to practice use of UseState().",
    repositorio:"https://github.com/RamonFavero/KeeperApp",
    projeto:"https://ramonfavero.github.io/KeeperApp/",
    buttonPTEN:"PAGE"
    },
    {id:3,
    title:"To-Do List",
    img:"https://github.com/RamonFavero/ramonportfolio/blob/main/src/img/todolist.png?raw=true",
    corpo:"This is a very simple task list project, great for firming knowledge in states, maps and props.",
    repositorio:"https://github.com/RamonFavero/todolist",
    projeto:"https://ramonfavero.github.io/todolist/",
    buttonPTEN:"PAGE"
    },
    {id:4,
    title:"Sign Up App",
    img:"https://github.com/RamonFavero/ramonportfolio/blob/main/src/img/signupapp.png?raw=true",
    corpo:"A login/registration page with the logic made only on the front-end to read the data and allow login/register.",
    repositorio:"https://github.com/RamonFavero/signupapp",
    projeto:"https://ramonfavero.github.io/signupapp",
    buttonPTEN:"PAGE"
    },
    {id:5,
    title:"Taskify",
    img:"https://github.com/RamonFavero/ramonportfolio/blob/main/src/img/taskify.png?raw=true",
    corpo:"My first project made with TypeScript. ",
    repositorio:"https://github.com/RamonFavero/taskify",
    projeto:"https://ramonfavero.github.io/taskify/",
    buttonPTEN:"PAGE"
    },
     {id:6,
title:"Spotflix",
img:"https://github.com/RamonFavero/ramonportfolio/blob/main/src/img/spotflix.png?raw=true",
corpo:"First time using Typescript extracting data from an open API. ",
repositorio:"https://github.com/RamonFavero/spotflix",
projeto:"https://ramonfavero.github.io/spotflix/",
buttonPTEN:"PAGE"
    },
    ]
    
    export default apresentationcontententEN